import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import UndoIcon from '@mui/icons-material/Undo';
import { useState } from 'react';
import EditPopUp, { PopUpStateType, PopUpTypes } from './EditPopUp/EditPopUp';
import { Button } from '@sm-dashboard/ui-components';

const EditPolygon = () => {
  const [startEdit, setStartEdit] = useState(false);
  const [polygons, setPolygons] = useState<google.maps.Polygon[]>([]);
  const [popUpState, setPopUpState] = useState<PopUpStateType>('');
  const [drawingManager] = useState<google.maps.drawing.DrawingManager>(
    new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
        drawingModes: [google.maps.drawing.OverlayType.POLYGON]
      },
      polygonOptions: {
        fillColor: '#ffff00',
        fillOpacity: 0.2,
        strokeWeight: 2,
        clickable: false,
        editable: true,
        zIndex: 15
      }
    })
  );

  google.maps.event.addListener(drawingManager, 'polygoncomplete', (polygon: google.maps.Polygon) => {
    setPolygons([...polygons, polygon]);
  });

  const handleStartEditing = () => {
    if (startEdit) {
      drawingManager.setMap(null);
      setPopUpState(PopUpTypes.PRINT_MAP);
    } else {
      setPopUpState(PopUpTypes.START_EDIT_POP_UP);
    }
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/972515415770', '_blank');
  };

  const handleUndo = () => {
    if (polygons.length > 0) {
      const lastPolygon = polygons[polygons.length - 1];
      lastPolygon.setMap(null);
      const newPolygons = polygons.slice(0, -1);
      setPolygons(newPolygons);
      if (newPolygons.length === 0) {
        setStartEdit(false);
        drawingManager.setMap(null);
      }
    }
  };
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: '8px',
        right: '8px',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 1,
        width: { xs: 'calc(95% - 16px)', md: 'auto' }
      }}
    >
      {startEdit && polygons.length > 0 && (
        <Button size="small" color="error" shape="square" startIcon={<UndoIcon fontSize="small" />} onClick={handleUndo}>
          ביטול
        </Button>
      )}
      <Button
        size="small"
        color="success"
        shape="square"
        startIcon={<WhatsAppIcon fontSize="small" />}
        onClick={handleWhatsAppClick}
      >
        פנייה והערות
      </Button>

      <Button
        size="small"
        color="warning"
        shape="square"
        startIcon={!startEdit ? <EditIcon fontSize="small" /> : <SaveIcon fontSize="small" />}
        onClick={handleStartEditing}
      >
        {startEdit ? 'שמירת הקובץ' : 'עריכת התיחום'}
      </Button>

      <EditPopUp
        setStartEdit={setStartEdit}
        drawingManager={drawingManager}
        popUpState={popUpState}
        setPopUpState={setPopUpState}
        polygons={polygons}
      />
    </Box>
  );
};

export default EditPolygon;
